import { createUser, getUserByUid } from 'api/users.api';
import { createUserWithEmailAndPassword, signInWithPopup } from 'firebase/auth';
import { $form, $user, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';
import { auth, provider } from 'utils/firebase';
import { validateEmail } from 'utils/validateEmail';
import { validatePassword } from 'utils/validatePassword';

export const handleSignupWithPassword = async () => {
  $view.update({ isLoading: true });

  const { email, password, confirmPassword } = $form.value;
  const emailValidation = validateEmail(email);
  const passwordValidation = validatePassword(password);
  const errs = [...emailValidation, ...passwordValidation];

  try {
    if (errs.length) throw new Error(errs[0]);
    if (password !== confirmPassword) throw new Error('Passwords do not match');

    $user.update({
      isCreatingUser: true,
    });

    const { user: fbUser } = await createUserWithEmailAndPassword(auth, email, password);
    await createUser({
      uid: fbUser.uid,
      email: fbUser.email,
      userTypeId: null,
      onboardingStep: 'todo',
      isVerified: true,
    });
    window.location.reload();
  } catch (error) {
    if (error.code === 'auth/email-already-in-use') {
      displayError({
        variant: 'warning',
        title: 'Authentication Error',
        message: 'Email already in use. This email is already associated with an account. Please try logging in or use a different email.',
      });
    } else if (error.code === 'auth/invalid-email') {
      displayError({
        variant: 'warning',
        title: 'Authentication Error',
        message: 'Invalid email. Please enter a valid email address.',
      });
    } else {
      displayError({
        variant: 'warning',
        title: 'Authentication Error',
        message: error.message,
      });
    }

    $form.update({
      isLoading: false,
    });
    $user.update({
      isCreatingUser: false,
    });
  } finally {
    $view.update({ isLoading: false });
  }
};

export const handleGoogleLogin = async (navigate) => {
  $view.update({ isLoading: true });

  try {
    $user.update({
      isCreatingUser: true,
    });

    const { user: fbUser } = await signInWithPopup(auth, provider);
    await getUserByUid(fbUser.uid)
      .then((user) => {
        if (user) {
          navigate(`/${user.userType}/dashboard`);
        }
      });
    await createUser({
      uid: fbUser.uid,
      email: fbUser.email,
      userTypeId: null,
      onboardingStep: 'todo',
      isVerified: true,
    });
    window.location.reload();
  } catch (error) {
    displayError({
      variant: 'warning',
      title: 'Authentication Error',
      message: error.message,
    });
  } finally {
    $view.update({ isLoading: false });
  }
};
